import BenefitsSection from "../../Components/BenefitdSection";
import BenefitSectionPlanPage from "../../Components/BenefitsSectionPlanPage";
import CapsuleSlider from "../../Components/CapsuleSlider";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import HealthServices from "../../Components/HealthServices";
import NavBar from "../../Components/NavBar";
import PricingSectionHome from "../../Components/PricingSectionHome/PricingSectionHome";
import SliderSection from "../../Components/SliderSection";
import UpgradeNetwork from "../../Components/UpgradeNetwork";
import WellnessHero from "../../Components/WellnessHero";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import CloseIcon from "../../Assets/Images/close-white-icon.svg";
import CheckIcon from "../../Assets/Images/check-white-icon.svg";

import TermPrIcon from "../../Assets/Images/product-t1.svg";
import UniversalPrIcon from "../../Assets/Images/product-t2.svg";
import IndexaPrIcon from "../../Assets/Images/product-t3.svg";
import CriticlePrIcon from "../../Assets/Images/product-t4.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import CompareMobile from "./CompareMobile";

function ComparePlans() {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();
  return (
    <>
      <NavBar onlyWhiteBg />
      <section
        id="product-compare"
        className="lg:mt-[8rem] pt-[8rem] pb-[4rem] lg:py-[6rem] "
      >
        <div className="container ">
          <div className="md:pl-[5px]">
            <h1 className="text-[24px] md:text-[40px] font-semibold mb-4 md:leading-[44px] leading-[28px] tracking-tight lg:pl-0 pl-[18px] reveal-up extra-title-heading">
              {translations.productCompareHeading}
            </h1>
            <p className="text-[14px] md:text-[16px] leading-[20px] md:leading-[22px] lg:pl-0 pl-[18px] reveal-up extra-title24">
              {translations.productCompareDescription}
            </p>
          </div>
          <div className="comparison-grid-Wrapper flex md:justify-end lg:mt-16 mt-8 mb-10  reveal-up hidden md:flex">
            <div className="w-[19%]  px-2  whitespace-normal">
              <div className="bg-[#FCF4E1] rounded-xl px-5 lg:py-12 py-12 h-full">
                <img className="mb-4" src={TermPrIcon} alt="" />
                <h3 className="text-[16px] font-semibold mb-4">
                  {translations.termProductTitle}
                </h3>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] mb-3">
                  {translations.termProductDescription1}
                </p>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] mb-0">
                  {translations.termProductDescription2}
                </p>
              </div>
            </div>
            <div className="w-[19%] px-2  whitespace-normal">
              <div className="bg-[#D8ECED] rounded-xl px-5 lg:py-12 py-12 h-full">
                <img className="mb-4" src={UniversalPrIcon} alt="" />
                <h3 className="text-[16px] font-semibold mb-4">
                  {translations.universalProductTitle}
                </h3>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] mb-3">
                  {translations.universalProductDescription1}
                </p>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] mb-3">
                  {translations.universalProductDescription2}
                </p>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] mb-0">
                  {translations.universalProductDescription3}
                </p>
              </div>
            </div>
            <div className="w-[19%] px-2   whitespace-normal">
              <div className="bg-[#488D93] rounded-xl px-5 lg:py-12 py-12 h-full">
                <img className="mb-4" src={IndexaPrIcon} alt="" />
                <h3 className="text-[16px] text-white font-semibold mb-4">
                  {translations.indexaProProductTitle}
                </h3>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] text-white mb-3">
                  {translations.indexaProProductDescription1}
                </p>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] text-white mb-3">
                  {translations.indexaProProductDescription2}
                </p>
                {/* <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] text-white mb-0">
                  {translations.indexaProProductDescription3}
                </p> */}
              </div>
            </div>
            <div className="w-[19%] px-2  whitespace-normal">
              <div className="bg-[#0D4248] rounded-xl px-5 lg:py-12 py-12 h-full">
                <img className="mb-4" src={CriticlePrIcon} alt="" />
                <h3 className="text-[16px] text-white font-semibold mb-4">
                  {translations.criticalProductTitle}
                </h3>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] text-white mb-3">
                  {translations.criticalProductDescription1}
                </p>
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-[20px] leading-[20px] text-white mb-0">
                  {translations.criticalProductDescription2}
                </p>
              </div>
            </div>
          </div>

          <div className="product-comparisonTable hidden md:block  reveal-up">
            <div className="flex items-center">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.guaranteedPremium}
              </div>
              <div className="w-[19%] p-5 flex justify-center flex-col items-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
                <p className="mt-2 text-[12px] leading-[18px] text-[#877D63] pc-table-during-terms">
                  {translations.duringTerms}
                </p>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
            <div className="flex items-center bg-[#F7F6F2] rounded-[26px]">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.cashValue}
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.premiumFlexibility}
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
            <div className="flex items-center bg-[#F7F6F2] rounded-[26px]">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.deathBenefit}
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.loanDuration}
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
            <div className="flex items-center bg-[#F7F6F2] rounded-[26px]">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.permanentPolicy}
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
            <div className="flex items-center">
              <div className="w-[24%] p-5 text-[16px] font-semibold tracking-tight pc-table-col">
                {translations.interestCredit}
                <p className="text-[14px] md:text-[11.5px] md:leading-[16px] xl:text-[14px] xl:leading-normal font-normal">
                  {translations.interestCreditDesc}
                </p>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#877D63] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#8BB6B8] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#488D93] rounded-full pc-table-col-circle">
                  <img src={CheckIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
              <div className="w-[19%] p-5 flex justify-center text-center">
                <div className="flex items-center justify-center w-4 h-4 bg-[#000000] rounded-full pc-table-col-circle">
                  <img src={CloseIcon} alt="Close Icon" className="w-2 h-2" />
                </div>
              </div>
            </div>
          </div>

          <CompareMobile />
        </div>
      </section>

      <FAQs />
      <HealthInsuranceHero />
    </>
  );
}

export default ComparePlans;
